// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wh5O","buttons":"styles_buttons__K7Ixh"};